import React from "react";
import { Col, Row, Form } from "antd";
import CheckBoxUC from "../../../components/Form/CheckBoxUC";
import InputUC from '../../../components/Form/InputUC'

const Information = ({ props }) => {
  const { form, isReadOnly } = props;

  const handleChange = (e, columnName) => {
    let inputValue = e.target.value;
    form.setFieldsValue({ [columnName]: inputValue });
  };

  const handleSetNull = (columnName) => {
    form.resetFields([columnName]);
  };

  const other = Form.useWatch("other", form);

  return (
    <>
      <div className="content-block p-3">
        <div className="block-title">ข่าวสารการรับสมัคร</div>
        <Row>
          <Col span={12}>
            <CheckBoxUC
              required={true}
              label="งาน Job Expo"
              name={"jobfair"}
              isShowHead={false}
              disabled={isReadOnly}
            />
          </Col>
          <Col span={12}>
            <CheckBoxUC
              required={true}
              label="Website รับสมัครงานอื่น ๆ"
              name={"board"}
              isShowHead={false}
              disabled={isReadOnly}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <CheckBoxUC
              required={true}
              label="เพจ Facebook สำนักงานบริหารทรัพยากรบุคคล สภากาชาดไทย"
              name={"internet"}
              isShowHead={false}
              disabled={isReadOnly}
            />
          </Col>
          <Col span={12}>
            <CheckBoxUC
              onChange={(ev) => handleSetNull("otherValue")}
              required={true}
              label="อื่น ๆ โปรดระบุ"
              name={"other"}
              isShowHead={false}
              disabled={isReadOnly}
            />
          </Col>
        </Row>
        {other && (
          <>
            <Row className="otherValue py-2">
              <Col span={12}></Col>
              <Col span={12} className="px-2">
                <InputUC
                  label={"อื่น ๆ "}
                  showLabel={false}
                  required={true}
                  name={"otherValue"}
                  placeholder={"กรุณากรอกอื่น ๆ "}
                  onChange={(ev) => handleChange(ev, 'otherValue')}
                  disabled={isReadOnly}
                />
              </Col>
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default Information;
